import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = {
    key: "actions",
    class: "float-end"
};
const _hoisted_6 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_7 = {
    key: 1,
    class: "clearfix"
};
const _hoisted_8 = { class: "form-contents" };
const _hoisted_9 = { class: "row" };
const _hoisted_10 = {
    key: "profile-panel",
    class: "col-xs-12 col-sm-12"
};
const _hoisted_11 = {
    key: "profile",
    class: "clearfix"
};
const _hoisted_12 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_13 = { class: "col-xs-12 col-sm-12" };
const _hoisted_14 = { class: "float-end" };
const _hoisted_15 = ["title"];
const _hoisted_16 = { class: "clearfix" };
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_18 = { class: "invalid-feedback" };
const _hoisted_19 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_20 = { class: "invalid-feedback" };
const _hoisted_21 = { class: "clearfix" };
const _hoisted_22 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_23 = { class: "invalid-feedback" };
const _hoisted_24 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_25 = { class: "invalid-feedback" };
const _hoisted_26 = { class: "clearfix" };
const _hoisted_27 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_28 = { class: "invalid-feedback" };
const _hoisted_29 = { class: "col-xs-12 col-sm-12 col-md-3 bottom10" };
const _hoisted_30 = { class: "invalid-feedback" };
const _hoisted_31 = { class: "col-xs-12 col-sm-12 col-md-3 bottom10" };
const _hoisted_32 = { class: "invalid-feedback" };
const _hoisted_33 = { class: "clearfix" };
const _hoisted_34 = { class: "col-xs-12 col-sm-12 bottom10" };
const _hoisted_35 = {
    key: 1,
    class: "clearfix"
};
const _hoisted_36 = { class: "col-xs-12 col-sm-12 bottom10" };
const _hoisted_37 = { class: "checkbox-wrapper" };
const _hoisted_38 = {
    key: 2,
    class: "clearfix"
};
const _hoisted_39 = { class: "col-xs-12 col-sm-12 bottom10" };
const _hoisted_40 = { class: "invalid-feedback" };
const _hoisted_41 = {
    key: "password",
    class: "clearfix"
};
const _hoisted_42 = { class: "clearfix" };
const _hoisted_43 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12 bottom10"
};
const _hoisted_44 = { class: "checkbox-wrapper" };
const _hoisted_45 = {
    key: 1,
    class: "clearfix"
};
const _hoisted_46 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_47 = { class: "invalid-feedback" };
const _hoisted_48 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_49 = { class: "invalid-feedback" };
const _hoisted_50 = { class: "col-xs-12 col-sm-12" };
const _hoisted_51 = {
    key: "permsission-panel",
    class: "col-xs-12 col-sm-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_AlertComponent = _resolveComponent("AlertComponent");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_PasswordLegendVue = _resolveComponent("PasswordLegendVue");
    const _component_b_alert = _resolveComponent("b-alert");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    const _component_UserCompanyAccessVue = _resolveComponent("UserCompanyAccessVue");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", {
                    class: _normalizeClass({ 'red-text': _ctx.isUserArchived })
                }, _toDisplayString(_ctx.pageTitle || 'Missing user name...'), 3 /* TEXT, CLASS */)
            ]),
            _cache[30] || (_cache[30] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    (_ctx.isNewUser || !_ctx.changingPassword)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_b_button, {
                                type: "button",
                                variant: "primary",
                                onClick: _ctx.save
                            }, {
                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                        _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]),
                            _cache[20] || (_cache[20] = _createTextVNode()),
                            _withDirectives(_createVNode(_component_b_button, {
                                type: "button",
                                variant: "danger",
                                onClick: _ctx.archive
                            }, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                        _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Archive", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]), [
                                [_vShow, !_ctx.isNewUser && !_ctx.isUserArchived && !_ctx.isThirdPartyAuth]
                            ]),
                            _cache[21] || (_cache[21] = _createTextVNode()),
                            _withDirectives(_createVNode(_component_b_button, {
                                type: "button",
                                variant: "warning",
                                onClick: _ctx.restore
                            }, {
                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                        _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Restore", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]), [
                                [_vShow, !_ctx.isNewUser && _ctx.isUserArchived && !_ctx.isThirdPartyAuth]
                            ]),
                            _cache[22] || (_cache[22] = _createTextVNode()),
                            _withDirectives(_createVNode(_component_b_button, {
                                type: "button",
                                variant: "warning",
                                onClick: _ctx.requestPasswordChange
                            }, {
                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                        _createElementVNode("i", { class: "fa fa-lock" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Change Password", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]), [
                                [_vShow, !_ctx.isNewUser && !_ctx.isThirdPartyAuth]
                            ]),
                            _cache[23] || (_cache[23] = _createTextVNode()),
                            _withDirectives(_createVNode(_component_b_button, {
                                type: "button",
                                variant: "warning",
                                onClick: _ctx.resetPassword
                            }, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                        _createElementVNode("i", { class: "fa fa-lock" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Reset Password", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]), [
                                [_vShow, !_ctx.isNewUser && !_ctx.isThirdPartyAuth]
                            ]),
                            _cache[24] || (_cache[24] = _createTextVNode()),
                            _withDirectives(_createVNode(_component_b_button, {
                                type: "button",
                                variant: "warning",
                                onClick: _ctx.clear2FAMethod
                            }, {
                                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                        _createElementVNode("i", { class: "fa fa-eraser" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Clear 2FA Method", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]), [
                                [_vShow, _ctx.hasTwoFactorAuth]
                            ]),
                            _cache[25] || (_cache[25] = _createTextVNode()),
                            _createVNode(_component_b_button, {
                                type: "button",
                                variant: "secondary",
                                onClick: _ctx.goBack
                            }, {
                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                        _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _cache[29] || (_cache[29] = _createTextVNode()),
                    (_ctx.changingPassword)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_b_button, {
                                type: "button",
                                variant: "primary",
                                onClick: _ctx.changePassword
                            }, {
                                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                        _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Save Password", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]),
                            _cache[28] || (_cache[28] = _createTextVNode()),
                            _createVNode(_component_b_button, {
                                type: "button",
                                variant: "secondary",
                                onClick: _ctx.requestPasswordChange
                            }, {
                                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                        _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ])
        ]),
        _cache[89] || (_cache[89] = _createTextVNode()),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_AlertComponent, { msg: _ctx.msg }, null, 8 /* PROPS */, ["msg"]),
                _cache[85] || (_cache[85] = _createTextVNode()),
                _cache[86] || (_cache[86] = _createElementVNode("div", { class: "col-xs-12 col-sm-12" }, null, -1 /* CACHED */)),
                _cache[87] || (_cache[87] = _createTextVNode()),
                _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_CollapsibleForm, null, {
                        default: _withCtx(() => {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
                            return [
                                (_ctx.isNewUser || !_ctx.changingPassword)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        (_ctx.userHasLoggedIn)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                _createElementVNode("div", _hoisted_13, [
                                                    _createElementVNode("div", _hoisted_14, [
                                                        _cache[32] || (_cache[32] = _createElementVNode("label", null, "Last Login", -1 /* CACHED */)),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.whenLastLoggedInString) + " ", 1 /* TEXT */),
                                                        (_ctx.userHasBeenSeen)
                                                            ? (_openBlock(), _createElementBlock("span", {
                                                                key: 0,
                                                                title: _ctx.whenLastSeenExactString
                                                            }, [
                                                                _cache[31] || (_cache[31] = _createElementVNode("label", null, "Last Seen", -1 /* CACHED */)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.whenLastSeenString), 1 /* TEXT */)
                                                            ], 8 /* PROPS */, _hoisted_15))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[66] || (_cache[66] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_16, [
                                            _createElementVNode("div", _hoisted_17, [
                                                _cache[33] || (_cache[33] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tUser Name *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[34] || (_cache[34] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.userNameVal, {
                                                    type: "text",
                                                    modelValue: _ctx.user.userName,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.user.userName) = $event)),
                                                    modelModifiers: { trim: true },
                                                    name: "userName",
                                                    class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.userName },
                                                    maxlength: "100",
                                                    disabled: _ctx.isThirdPartyAuth
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "disabled"]),
                                                _cache[35] || (_cache[35] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_18, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a user name\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.userName]
                                                ])
                                            ]),
                                            _cache[40] || (_cache[40] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_19, [
                                                _cache[37] || (_cache[37] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tRole *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[38] || (_cache[38] = _createTextVNode()),
                                                _createVNode(_component_multiselect, _mergeProps(_ctx.roleVal, {
                                                    name: "role",
                                                    modelValue: _ctx.role,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.role) = $event)),
                                                    "track-by": "value",
                                                    label: "text",
                                                    placeholder: _ctx.selectPlaceholder,
                                                    options: _ctx.roles,
                                                    showLabels: false,
                                                    allowEmpty: false,
                                                    class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.role }
                                                }), {
                                                    noResult: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 16 /* FULL_PROPS */, ["modelValue", "placeholder", "options", "class"]),
                                                _cache[39] || (_cache[39] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_20, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please select a role\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.role]
                                                ])
                                            ])
                                        ]),
                                        _cache[67] || (_cache[67] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("div", _hoisted_22, [
                                                _cache[41] || (_cache[41] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tFirst Name *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[42] || (_cache[42] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.firstNameVal, {
                                                    type: "text",
                                                    modelValue: _ctx.user.firstName,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.user.firstName) = $event)),
                                                    name: "firstName",
                                                    class: { 'is-invalid': (_e = _ctx.errors) === null || _e === void 0 ? void 0 : _e.firstName },
                                                    maxlength: "50"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _cache[43] || (_cache[43] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_23, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a first name\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_f = _ctx.errors) === null || _f === void 0 ? void 0 : _f.firstName]
                                                ])
                                            ]),
                                            _cache[47] || (_cache[47] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_24, [
                                                _cache[44] || (_cache[44] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tLast Name *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[45] || (_cache[45] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.lastNameVal, {
                                                    type: "text",
                                                    modelValue: _ctx.user.lastName,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.user.lastName) = $event)),
                                                    name: "lastName",
                                                    class: { 'is-invalid': (_g = _ctx.errors) === null || _g === void 0 ? void 0 : _g.lastName },
                                                    maxlength: "50"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _cache[46] || (_cache[46] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_25, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a last name\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_h = _ctx.errors) === null || _h === void 0 ? void 0 : _h.lastName]
                                                ])
                                            ])
                                        ]),
                                        _cache[68] || (_cache[68] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_26, [
                                            _createElementVNode("div", _hoisted_27, [
                                                _cache[48] || (_cache[48] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tEmail\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[49] || (_cache[49] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.emailVal, {
                                                    type: "email",
                                                    modelValue: _ctx.user.emailAddress,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.user.emailAddress) = $event)),
                                                    name: "email",
                                                    class: { 'is-invalid': (_j = _ctx.errors) === null || _j === void 0 ? void 0 : _j.email },
                                                    maxlength: "255"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _cache[50] || (_cache[50] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_28, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a valid email\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_k = _ctx.errors) === null || _k === void 0 ? void 0 : _k.email]
                                                ])
                                            ]),
                                            _cache[57] || (_cache[57] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_29, [
                                                _cache[51] || (_cache[51] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tWork Phone\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[52] || (_cache[52] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.workPhoneVal, {
                                                    type: "tel",
                                                    modelValue: _ctx.user.workPhone,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.user.workPhone) = $event)),
                                                    name: "workPhone",
                                                    class: { 'is-invalid': (_l = _ctx.errors) === null || _l === void 0 ? void 0 : _l.workPhone },
                                                    maxlength: "50"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _cache[53] || (_cache[53] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_30, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a valid phone number\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_m = _ctx.errors) === null || _m === void 0 ? void 0 : _m.workPhone]
                                                ])
                                            ]),
                                            _cache[58] || (_cache[58] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_31, [
                                                _cache[54] || (_cache[54] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tMobile Phone\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[55] || (_cache[55] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.mobilePhoneVal, {
                                                    type: "tel",
                                                    modelValue: _ctx.user.mobilePhone,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.user.mobilePhone) = $event)),
                                                    name: "mobilePhone",
                                                    class: { 'is-invalid': (_o = _ctx.errors) === null || _o === void 0 ? void 0 : _o.mobilePhone },
                                                    maxlength: "50"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _cache[56] || (_cache[56] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_32, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a valid phone number\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_p = _ctx.errors) === null || _p === void 0 ? void 0 : _p.mobilePhone]
                                                ])
                                            ])
                                        ]),
                                        _cache[69] || (_cache[69] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_33, [
                                            _createElementVNode("div", _hoisted_34, [
                                                _cache[59] || (_cache[59] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tPosition / Title\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[60] || (_cache[60] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, {
                                                    type: "text",
                                                    modelValue: _ctx.user.position,
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.user.position) = $event)),
                                                    maxlength: "100"
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ])
                                        ]),
                                        _cache[70] || (_cache[70] = _createTextVNode()),
                                        (_ctx.isClientAdmin)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                _createElementVNode("div", _hoisted_36, [
                                                    _createElementVNode("div", _hoisted_37, [
                                                        _createVNode(_component_b_form_checkbox, {
                                                            id: "hidden",
                                                            modelValue: _ctx.user.hidden,
                                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.user.hidden) = $event)),
                                                            size: "lg"
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tHide user from selection lists\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                ]))]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["modelValue"])
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[71] || (_cache[71] = _createTextVNode()),
                                        (_ctx.isNewUser && !_ctx.isPowerShield)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                _createElementVNode("div", _hoisted_39, [
                                                    _cache[63] || (_cache[63] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tCompany *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                    _cache[64] || (_cache[64] = _createTextVNode()),
                                                    _createVNode(_component_multiselect, _mergeProps(_ctx.authorizedCompanyIdVal, {
                                                        name: "authorizedCompany",
                                                        modelValue: _ctx.authorizedCompany,
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.authorizedCompany) = $event)),
                                                        "track-by": "value",
                                                        label: "text",
                                                        placeholder: _ctx.selectPlaceholder,
                                                        options: _ctx.companies,
                                                        showLabels: false,
                                                        allowEmpty: false,
                                                        class: { 'is-invalid': (_q = _ctx.errors) === null || _q === void 0 ? void 0 : _q.authorizedCompanyId }
                                                    }), {
                                                        noResult: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                            ]))]),
                                                        _: 1 /* STABLE */
                                                    }, 16 /* FULL_PROPS */, ["modelValue", "placeholder", "options", "class"]),
                                                    _cache[65] || (_cache[65] = _createTextVNode()),
                                                    _withDirectives(_createElementVNode("div", _hoisted_40, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please select a company\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                        [_vShow, (_r = _ctx.errors) === null || _r === void 0 ? void 0 : _r.authorizedCompanyId]
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _cache[84] || (_cache[84] = _createTextVNode()),
                                ((_ctx.isNewUser && _ctx.isPowerShield) || _ctx.changingPassword)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                        _createElementVNode("div", _hoisted_42, [
                                            (_ctx.isNewUser)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                    _createElementVNode("div", _hoisted_44, [
                                                        _createVNode(_component_b_form_checkbox, _mergeProps(_ctx.generatePasswordVal, {
                                                            id: "generateRandomPassword",
                                                            modelValue: _ctx.generateRandomPassword,
                                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.generateRandomPassword) = $event)),
                                                            size: "lg"
                                                        }), {
                                                            default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tSend user an email to set their password\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                ]))]),
                                                            _: 1 /* STABLE */
                                                        }, 16 /* FULL_PROPS */, ["modelValue"])
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _cache[83] || (_cache[83] = _createTextVNode()),
                                            (!_ctx.generateRandomPassword)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                    _createElementVNode("div", _hoisted_46, [
                                                        _cache[73] || (_cache[73] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tPassword *\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                        _cache[74] || (_cache[74] = _createTextVNode()),
                                                        _createVNode(_component_b_form_input, _mergeProps(_ctx.passwordVal, {
                                                            type: "password",
                                                            modelValue: _ctx.userPassword.password,
                                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.userPassword.password) = $event)),
                                                            name: "password",
                                                            class: { 'is-invalid': (_s = _ctx.errors) === null || _s === void 0 ? void 0 : _s.password },
                                                            ref: "password",
                                                            autocomplete: "new-password",
                                                            rules: "customPassword"
                                                        }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                        _cache[75] || (_cache[75] = _createTextVNode()),
                                                        _withDirectives(_createElementVNode("div", _hoisted_47, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t* Please enter a valid password\r\n\t\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                            [_vShow, (_t = _ctx.errors) === null || _t === void 0 ? void 0 : _t.password]
                                                        ]),
                                                        _cache[76] || (_cache[76] = _createTextVNode()),
                                                        _createVNode(_component_PasswordLegendVue)
                                                    ]),
                                                    _cache[81] || (_cache[81] = _createTextVNode()),
                                                    _createElementVNode("div", _hoisted_48, [
                                                        _cache[77] || (_cache[77] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tConfirm Password *\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                        _cache[78] || (_cache[78] = _createTextVNode()),
                                                        _createVNode(_component_b_form_input, _mergeProps(_ctx.passwordConfirmationVal, {
                                                            type: "password",
                                                            modelValue: _ctx.userPassword.passwordConfirmation,
                                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.userPassword.passwordConfirmation) = $event)),
                                                            name: "confirmationPassword",
                                                            class: { 'is-invalid': (_u = _ctx.errors) === null || _u === void 0 ? void 0 : _u.passwordConfirmation },
                                                            autocomplete: "new-password",
                                                            rules: "customPassword"
                                                        }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                        _cache[79] || (_cache[79] = _createTextVNode()),
                                                        _withDirectives(_createElementVNode("div", _hoisted_49, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t* The confirmation password does not match with the password\r\n\t\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                            [_vShow, (_v = _ctx.errors) === null || _v === void 0 ? void 0 : _v.passwordConfirmation]
                                                        ])
                                                    ]),
                                                    _cache[82] || (_cache[82] = _createTextVNode()),
                                                    _createElementVNode("div", _hoisted_50, [
                                                        _createVNode(_component_b_alert, {
                                                            show: "",
                                                            variant: "primary"
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[80] || (_cache[80] = [
                                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t* Minimum password length is 7 characters. Please use a mix of letters and numbers, as well as upper and lower-case characters.\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                ]))]),
                                                            _: 1 /* STABLE */
                                                        })
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ];
                        }),
                        _: 1 /* STABLE */
                    })
                ]),
                _cache[88] || (_cache[88] = _createTextVNode()),
                (!_ctx.isNewUser && _ctx.isClient)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createVNode(_component_UserCompanyAccessVue, {
                            userId: _ctx.userId,
                            roleId: _ctx.roleId
                        }, null, 8 /* PROPS */, ["userId", "roleId"])
                    ]))
                    : _createCommentVNode("v-if", true)
            ])
        ])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
